export default "__VITE_ASSET__5c6204fe__"